import { useState } from "react";

// css
import "./FloatingButton.css";

// config
import colors from "../../../config/colors";

// components

function FloatingButton({ 
  bottom = "8%",
  onPressedAction,
  width = 35,
  height = 35,
  borderRadius = 35,
  backgroundColor = colors.primary,
  right = 15,
  icon,
  onMouseEnter,
  onMouseLeave,
  showTooltip,
  actionTitle = '',
  copyTooltipTop = -95
}) {
  const [isPressed, setIsPressed] = useState(false);
  const handleClick = () => {
    setIsPressed(true);

    onPressedAction();
    setTimeout(() => setIsPressed(false), 150);
  };

  return (
    <div className="floating-button-wrapper" style={{ bottom, right }}>
      {
      showTooltip && (
        <div className="copy-tooltip" style={{ top: copyTooltipTop }}>
          {
            isPressed && <span>{actionTitle}</span>
          }
          Copied
        </div>
      )}
      <div
        className="floating-button-box"
        style={{
          width,
          height,
          borderRadius,
          backgroundColor,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          bottom,
          right,
          cursor: "pointer",
          opacity: isPressed ? 0.6 : 1,
          transform: "0.2s",
        }}
        onClick={() => handleClick()}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {
          icon
        }
      </div>
    </div>
  );
}

export default FloatingButton;
